import instance from "@/services/api";

const prefix = "/notifications";

export default {
  getInbox({ page = 1, pageSize = 20, unreadOnly = false, sourceModule = null } = {}) {
    return instance(true, null, { showToast: false })
      .get(`${prefix}/`, {
        params: {
          page,
          page_size: pageSize,
          unread_only: unreadOnly ? 1 : 0,
          source_module: sourceModule || undefined,
        },
      })
      .then((r) => r?.data?.data || {});
  },
  // { count, latest_id }
  getSummary() {
    return instance(true, null, { showToast: false })
      .get(`${prefix}/unread-count/`)
      .then((r) => r?.data?.data || {});
  },
  markRead(notificationId) {
    return instance(true, null, { showToast: false })
      .patch(`${prefix}/${notificationId}/read/`)
      .then((r) => r?.data);
  },
  markAllRead() {
    return instance(true, null, { showToast: false })
      .post(`${prefix}/read-all/`)
      .then((r) => r?.data);
  },
};
